import * as React from "react";

const GoogleSheetIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="36"
    fill="none"
    viewBox="0 0 26 36"
    className={className}
  >
    <mask
      id="mask0_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask0_3512_10079)">
      <path
        fill="#0F9D58"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053l-5.43-3.974z"
      ></path>
    </g>
    <mask
      id="mask1_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask1_3512_10079)">
      <path
        fill="#F1F1F1"
        d="M6.291 17.603v11.524h12.41V17.603zm5.43 9.934H7.842V25.55h3.879zm0-3.179H7.842v-1.987h3.879zm0-3.179H7.842v-1.987h3.879zm5.43 6.358h-3.879V25.55h3.879zm0-3.179h-3.879v-1.987h3.879zm0-3.179h-3.879v-1.987h3.879z"
      ></path>
    </g>
    <mask
      id="mask2_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask2_3512_10079)">
      <path
        fill="url(#paint0_linear_3512_10079)"
        d="m16.28 9.355 8.628 8.838v-8.14z"
      ></path>
    </g>
    <mask
      id="mask3_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask3_3512_10079)">
      <path
        fill="#87CEAC"
        d="M15.6.515v7.153c0 1.317 1.04 2.385 2.326 2.385h6.982z"
      ></path>
    </g>
    <mask
      id="mask4_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask4_3512_10079)">
      <path
        fill="#fff"
        fillOpacity="0.2"
        d="M2.413.515C1.133.515.086 1.588.086 2.9v.2C.086 1.786 1.133.713 2.413.713h13.186V.515z"
      ></path>
    </g>
    <mask
      id="mask5_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask5_3512_10079)">
      <path
        fill="#263238"
        fillOpacity="0.2"
        d="M22.932 35.286H2.764c-1.28 0-2.327-1.073-2.327-2.384v.198c0 1.312 1.047 2.385 2.327 2.385h20.168c1.28 0 2.327-1.073 2.327-2.385v-.198c0 1.311-1.047 2.384-2.327 2.384"
      ></path>
    </g>
    <mask
      id="mask6_3512_10079"
      width="25"
      height="36"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </mask>
    <g mask="url(#mask6_3512_10079)">
      <path
        fill="#263238"
        fillOpacity="0.1"
        d="M17.926 10.052c-1.285 0-2.327-1.067-2.327-2.384v.199c0 1.317 1.042 2.384 2.327 2.384h6.982v-.199z"
      ></path>
      <path
        fill="url(#paint1_radial_3512_10079)"
        d="M15.6.515H2.412C1.133.515.086 1.588.086 2.9v30.202c0 1.311 1.047 2.384 2.327 2.384H22.58c1.28 0 2.326-1.073 2.326-2.384V10.053z"
      ></path>
    </g>
    <defs>
      <radialGradient
        id="paint1_radial_3512_10079"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(40.0249 0 0 41.0101 .872 1.21)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.1"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </radialGradient>
      <linearGradient
        id="paint0_linear_3512_10079"
        x1="20.594"
        x2="20.594"
        y1="10.114"
        y2="18.194"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#263238" stopOpacity="0.2"></stop>
        <stop offset="1" stopColor="#263238" stopOpacity="0.02"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default GoogleSheetIcon;
